import { render, staticRenderFns } from "./FooterNavi.vue?vue&type=template&id=af476880&scoped=true&"
import script from "./FooterNavi.vue?vue&type=script&lang=js&"
export * from "./FooterNavi.vue?vue&type=script&lang=js&"
import style0 from "./FooterNavi.vue?vue&type=style&index=0&id=af476880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af476880",
  null
  
)

export default component.exports